export default __webpack_public_path__ + "static/media/phone.8de89c0f.svg";